import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api, media, fmtDate } from "@/lib/api";
import { SectionHead } from "@/components/fo/Bits";
import { Parallax } from "@/components/fo/Motion";

const KINDS = [["", "All"], ["interview", "Interviews"], ["review", "Reviews"], ["news", "News"]];

export function Blog() {
  const [kind, setKind] = useState("");
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/articles", { params: { kind } }).then((r) => setList(r.data)); }, [kind]);
  return (
    <div className="mx-auto max-w-7xl px-4 pb-24 pt-28 md:px-8" data-testid="blog-page">
      <SectionHead label="Magazine" title="Fuorionda Magazine">Interviews with chart winners, honest reviews and news from the indie scene.</SectionHead>
      <div className="mb-10 flex flex-wrap gap-2">
        {KINDS.map(([v, l]) => (
          <button key={v} data-testid={`blog-filter-${v || "all"}`} onClick={() => setKind(v)}
            className={`rounded-full border px-4 py-1.5 font-mono text-[11px] uppercase tracking-widest ${kind === v ? "border-[#00F5D4] bg-[#00F5D4] text-[#07090E]" : "border-white/15 text-slate-400"}`}>{l}</button>
        ))}
      </div>
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {list.map((a, i) => (
          <Link key={a.id} to={`/blog/${a.slug}`} data-testid={`article-card-${a.slug}`} className={`group panel fade-up overflow-hidden hover:border-[#00F5D4]/40 ${i === 0 ? "md:col-span-2" : ""}`}>
            <div className={`${i === 0 ? "aspect-[21/9]" : "aspect-video"} overflow-hidden`}>{a.cover && <img src={media(a.cover)} alt="" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />}</div>
            <div className="p-6"><span className="label-mono">{a.kind} · {fmtDate(a.created_at)}</span><h3 className="mt-3 font-display text-2xl font-bold leading-tight">{a.title}</h3><p className="mt-2 text-sm text-slate-400">{a.excerpt}</p></div>
          </Link>
        ))}
      </div>
      {!list.length && <p className="py-16 text-center text-slate-500">Nothing published here yet.</p>}
    </div>
  );
}

export function Article() {
  const { slug } = useParams();
  const [a, setA] = useState(null);
  useEffect(() => { api.get(`/articles/${slug}`).then((r) => setA(r.data)).catch(() => setA(false)); }, [slug]);
  if (a === false) return <div className="pt-40 text-center text-slate-400">Article not found.</div>;
  if (!a) return null;
  return (
    <article className="pb-24" data-testid="article-page">
      <div className="relative h-[60vh] overflow-hidden">
        {a.cover && <Parallax speed={-0.25} className="absolute -inset-y-20 inset-x-0"><img src={media(a.cover)} alt="" className="h-full w-full object-cover" /></Parallax>}
        <div className="absolute inset-0 bg-gradient-to-t from-[#07090E] to-[#07090E]/30" />
      </div>
      <div className="relative mx-auto -mt-40 max-w-3xl px-4 md:px-8">
        <span className="label-mono">{a.kind} · {fmtDate(a.created_at)}</span>
        <h1 data-testid="article-title" className="mt-4 font-display text-4xl font-black leading-tight sm:text-5xl">{a.title}</h1>
        <p className="mt-5 text-xl text-slate-300">{a.excerpt}</p>
        <div className="prose-fo mt-10" data-testid="article-content">{(a.content || "").split(/\n\n+/).map((p, i) => <p key={i} className="whitespace-pre-line">{p}</p>)}</div>
        {a.artist && <Link to={`/a/${a.artist.slug}`} className="btn-hot mt-8" data-testid="article-artist-link">Discover {a.artist.stage_name}</Link>}
      </div>
    </article>
  );
}
